import api from '../services/api';
import { clearClientAuthStorage, redirectToPublicHome } from './authStorage';

export { clearClientAuthStorage, redirectToPublicHome } from './authStorage';

export async function performClientLogout() {
  clearClientAuthStorage();
  try {
    await api.post('/auth/logout');
  } catch {
    /* still leave the app locally and reload */
  }
  redirectToPublicHome();
}
